module.exports = __webpack_public_path__ + "img/white_otameshi.108c6c89.gif";